import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ObserverNav from '../components/ObserverNav';
import SupportTicketsPage from '../components/SupportTicketsPage';
import { HelpCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ObserverSupport() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('observer_token')) navigate('/observer/login');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <ObserverNav />

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
              <HelpCircle className="w-6 h-6 text-purple-600" />
              Support Center
            </h1>
            <p className="text-gray-600 text-sm mt-1">Raise a ticket — our team responds within 24–48 hours.</p>
          </div>
        </div>

        <SupportTicketsPage
          tokenKey="observer_token"
          role="observer"
          portalTitle="Observer Support"
          onBack={() => navigate('/observer/dashboard')}
          headerless
        />
      </div>
    </div>
  );
}
